import { getUserId } from '../utils/user';
var userId = getUserId();
export var RETURN_PATH = "/customer/returns/v1";
export var OMS_PATH = '/oms/customer/order/v1';
// RETURN SERVICE PATHS
export var RETURN_SERVICE_ELIGIBILITY = "".concat(RETURN_PATH, "/checkEligibility");
export var PRINT_RETURN_SHIPPING_LABEL_PATH = "".concat(RETURN_PATH, "/user/").concat(userId, "/print/returnshippinglabel");
export var POLICY_VALIDATOR = "".concat(RETURN_PATH, "/user/").concat(userId, "/ssrhrtvpolicyvalidator");
export var REFUND_ESTIMATION = "".concat(OMS_PATH, "/refund/estimation");
export var SS_RETURN_CREATE = "".concat(RETURN_PATH, "/user/").concat(userId, "/ssrreturncreate");
export var FINALIZE_SORIS_RETURN = "".concat(RETURN_PATH, "/createsoris");
export var VALIDATE_ADDRESS = "".concat(RETURN_PATH, "/validate/address");
export var VALIDATE_ZIPCODE = "".concat(RETURN_PATH, "/validate/zipCode");
